/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function BagIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg fill="none" stroke="currentColor" viewBox="0 0 20 20" aria-hidden="true" {...props}>
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M13.125 8.75V5C13.125 4.1712 12.7958 3.37634 12.2097 2.79029C11.6237 2.20424 10.8288 1.875 10 1.875C9.1712 1.875 8.37634 2.20424 7.79029 2.79029C7.20424 3.37634 6.875 4.1712 6.875 5V8.75M16.3383 7.08917L17.3908 17.0892C17.4492 17.6433 17.0158 18.125 16.4583 18.125H3.54167C3.41017 18.1251 3.28012 18.0976 3.15996 18.0442C3.03979 17.9908 2.93221 17.9127 2.84419 17.8151C2.75616 17.7174 2.68968 17.6023 2.64905 17.4772C2.60841 17.3521 2.59454 17.2199 2.60833 17.0892L3.66167 7.08917C3.68596 6.8588 3.79469 6.64558 3.96688 6.49063C4.13906 6.33568 4.36252 6.24996 4.59417 6.25H15.4058C15.8858 6.25 16.2883 6.6125 16.3383 7.08917ZM7.1875 8.75C7.1875 8.83288 7.15458 8.91237 7.09597 8.97097C7.03737 9.02958 6.95788 9.0625 6.875 9.0625C6.79212 9.0625 6.71263 9.02958 6.65403 8.97097C6.59542 8.91237 6.5625 8.83288 6.5625 8.75C6.5625 8.66712 6.59542 8.58763 6.65403 8.52903C6.71263 8.47042 6.79212 8.4375 6.875 8.4375C6.95788 8.4375 7.03737 8.47042 7.09597 8.52903C7.15458 8.58763 7.1875 8.66712 7.1875 8.75ZM13.4375 8.75C13.4375 8.83288 13.4046 8.91237 13.346 8.97097C13.2874 9.02958 13.2079 9.0625 13.125 9.0625C13.0421 9.0625 12.9626 9.02958 12.904 8.97097C12.8454 8.91237 12.8125 8.83288 12.8125 8.75C12.8125 8.66712 12.8454 8.58763 12.904 8.52903C12.9626 8.47042 13.0421 8.4375 13.125 8.4375C13.2079 8.4375 13.2874 8.47042 13.346 8.52903C13.4046 8.58763 13.4375 8.66712 13.4375 8.75Z"
            />
        </svg>
    );
}
